/**
 * NX-5555 — the single source for the Margin / Margin Adjustment / Net Margin
 * trio, shared by the report listings and the single-payroll detail page.
 *
 * The record stores the ADJUSTED margin in `margin` and the pre-adjustment
 * value in `payeeUmbrellaValue.marginAutoReducedFrom` (absent when nothing was
 * adjusted), so all three figures derive from what is already there.
 *
 *   Margin            what the margin should have been   (250)
 *   Margin Adjustment how much NMW ate into it           (21)
 *   Net Margin        what is actually taken             (229)
 *
 * With no adjustment: adjustment = 0 and net === gross.
 *
 * Deliberately shared rather than duplicated: the listing and the detail page
 * previously both said "Margin" while meaning different numbers, which is the
 * drift this module exists to prevent.
 */
export type MarginFiguresInput = {
  margin?: number | string | null;
  payeeUmbrellaValue?: {
    marginAutoReducedFrom?: number | string | null;
  } | null;
};

export const marginFigures = (
  record?: MarginFiguresInput | null,
  isPayee = false,
): { gross: number; adjustment: number; net: number } => {
  const net = isPayee ? 0 : Number(record?.margin ?? 0);
  const reducedFrom = record?.payeeUmbrellaValue?.marginAutoReducedFrom;
  const gross = reducedFrom != null ? Number(reducedFrom) : net;
  // a stored gross below net is never expected; clamp so it cannot render negative
  const adjustment = Math.max(0, +(gross - net).toFixed(2));
  return { gross, adjustment, net };
};
